import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable() export class HttpConfigInterceptor implements HttpInterceptor {

    constructor(private authService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let loginUser;
        try {
            loginUser = JSON.parse(localStorage.getItem('currentUser'));
        } catch (e) { }
        const token: string = loginUser ? loginUser.token : "";
        // only send the session token to our own API, never to third-party hosts
        const isApiRequest = request.url.indexOf(environment.apiURL) === 0;
        if (token && isApiRequest) {
            request = request.clone({ headers: request.headers.set('token', token) });
        }

        return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
            // the API answers an invalid or expired token with HTTP 200 and returnCode 403
            if (token && isApiRequest && event instanceof HttpResponse && event.body && event.body.returnCode == 403) {
                this.authService.logOut();
            }
        }, (err: any) => {
            // a missing or rejected token comes back as HTTP 401/403
            if (token && isApiRequest && err instanceof HttpErrorResponse && (err.status === 401 || err.status === 403)) {
                this.authService.logOut();
            }
        }));
    }
}



// WEBPACK FOOTER //
// ./src/app/services/httpconfig.interceptor.ts